// src/config/env.ts

// Detect device type (for LAN testing)
const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

// Detect if running inside Docker (frontend container)
const isDocker =
    typeof window !== "undefined" &&
    (window.location.hostname.includes("frontend_container") ||
        window.location.hostname.includes("docker") ||
        window.location.hostname.includes("container"));

// Helper for selecting base URL
function pickEnv(dev: string, lan: string, prod: string, docker?: string) {
    const isHostedBrowser =
        typeof window !== "undefined" &&
        (
            window.location.hostname.endsWith(".onrender.com") ||
            window.location.hostname === "qitplaylist.com" ||
            window.location.hostname.endsWith(".qitplaylist.com")
        );

    const normalizeProdBase = (value: string) => {
        const candidate = String(value || "").trim();
        if (!candidate) return "/api";
        if (candidate.startsWith("/")) return candidate;

        if (typeof window !== "undefined") {
            const isHttpsPage = window.location.protocol === "https:";
            const isLocalHost =
                window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1";
            let parsedUrl: URL;

            try {
                parsedUrl = new URL(candidate, window.location.origin);
            } catch {
                return "/api";
            }

            if (isHttpsPage && parsedUrl.protocol === "http:") {
                return "/api";
            }

            if (!isLocalHost && /:8080(?:\/|$)/.test(candidate)) {
                return "/api";
            }

            if (!isLocalHost && parsedUrl.origin !== window.location.origin) {
                return "/api";
            }
        }

        return candidate;
    };

    if (isHostedBrowser) return normalizeProdBase(prod || dev);
    if (import.meta.env.PROD) return normalizeProdBase(prod || dev);
    if (isDocker && docker) return docker;
    return isMobile ? (lan || dev) : dev;
}

export const env = {
    // 🌍 General API
    API_BASE: pickEnv(
        import.meta.env.VITE_API_BASE,
        import.meta.env.VITE_API_BASE_LAN,
        import.meta.env.VITE_API_BASE_PROD,
        import.meta.env.VITE_API_BASE_DOCKER
    ),


    PUSHER_KEY: import.meta.env.VITE_PUSHER_KEY,
    PUSHER_CLUSTER: import.meta.env.VITE_PUSHER_CLUSTER,

    // 🔑 Tokens
    AUTH_TOKEN: import.meta.env.VITE_AUTH_TOKEN,
    POSTMAN_TOKEN: import.meta.env.VITE_POSTMAN_TOKEN,

    // 🔒 Security
    TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY,
};
